import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ProjectCol from '../project-col/ProjectCol';

class ProjectRows extends Component {
  static propTypes = {
    projects: PropTypes.arrayOf(PropTypes.object),
    requireSort: PropTypes.bool,
  };

  static defaultProps = {
    requireSort: false,
  };

  render() {
    const { projects, requireSort } = this.props;

    if (requireSort) {
      projects.sort((a, b) => b.sizeClass - a.sizeClass);
    }

    let rows = [];
    let rowCounts = [];
    for (let [projectIdx, project] of projects.entries()) {
      let appendToRow;

      // find a suitable row to insert project col
      for (let [idx, rowCount] of rowCounts.entries()) {
        if (rowCount + project.sizeClass <= 12) {
          appendToRow = rows[idx];
          rowCounts[idx] = rowCount + project.sizeClass;
          break;
        }
      }

      if (!appendToRow) {
        rows.push([]);
        rowCounts.push(project.sizeClass);
        appendToRow = rows[rows.length - 1];
      }

      appendToRow.push(<ProjectCol project={project} key={projectIdx} />);
    }

    rows = rows.map((row, idx) =>
      <div className={classnames('row')} key={idx}>{row}</div>
    );
    return (
      <section>{rows}</section>
    );
  }
}

export default ProjectRows;



// WEBPACK FOOTER //
// ./src/components/project-rows/ProjectRows.js